export default "<r-renegotiate-loan #renegotiateLoanRef></r-renegotiate-loan>\n";